<!-- 人机对战-->
<template>
  <div class="man-machine">
    <div class="header">
      <div class="user">
        <div class="img">
          <img :src="studentInfo.avatar" alt>
        </div>
        <div class="user-item">
          <div class="username longText" style="display:flex;">
            <div class="longText" style="max-width:100%;">{{studentInfo.nickname}}</div>
            <span>{{extend_info.k_value/1000}}K</span>
          </div>
          <div class="status">提 {{winStep}} 子</div>
        </div>
      </div>

      <div class="vs">
        <div>VS</div>
        <div class="witchWin">{{whoisWIN}}</div>
      </div>
      <div class="user">
        <div class="img">
          <img :src="ETimg" alt>
        </div>
        <div class="user-item">
          <div class="username longText" style="display:flex;">
            <div class="longText" style="max-width:100%;">{{ETname}}</div>
            <span>{{ETk_value}}K</span>
          </div>
          <div class="status">提 {{machineStep}} 子</div>
        </div>
      </div>
    </div>
    <div class="container">
      <!--人机-->
      <canvas width="500" height="500" ref="machineRes"></canvas>
    </div>
    <div class="nav">
      <img src="../assets/imgs/mechineRes/first.png" @click="goStep('first')" alt="">
      <img src="../assets/imgs/mechineRes/prev.png"  @click="goStep(-1)" alt="">
      <img src="../assets/imgs/mechineRes/next.png"  @click="goStep(1)" alt="">
      <img src="../assets/imgs/mechineRes/last.png"  @click="goStep('last')" alt="">
    </div>
  </div>
</template>

<script>
import { mechineNameArr } from '../utils/const';
import Island from '../lib/island';
import * as Api from '../api/index';
import util from '../utils/util';

export default {
  name: 'manETResult',
  data() {
    return {
      studentInfo: {}, // 学生信息
      extend_info: {}, // k值
      winStep: 0, // 学生提子数
      machineStep: 0, // 机器人提子
      ETname: '船长妈妈', // 机器人姓名
      ETimg: '', // 机器人头像
      ETk_value: '', // 机器人K值
      whoisWIN: '黑胜', // 谁胜
      resID: '', // 当前对弈id
      desc: '', // 研究棋谱
    };
  },
  watch: {
    ETname() {
      this.initMechineInfo();
    },
    desc() {
      this.ETresult();
    },
  },
  created() {
    Api.studentList().then((res) => {
      if (res.status === 0) {
        this.studentInfo = res.content.base_info;
        this.extend_info = res.content.extend_info;
      }
    });
    this.resID = util.getUrlpar().id;
    console.log(util.getUrlpar());
  },
  mounted() {
    this.$store.dispatch('changLoadingStatus', false);
    this.getResult();
    this.ETresult();
    this.initMechineInfo();
  },
  computed: {
  },
  methods: {
    // 提示消息
    msg(str) {
      this.$toast(str);
    },
    // 初始化人机姓名头像
    initMechineInfo() {
      console.log(mechineNameArr);
      const mechineName = mechineNameArr.filter(({ name }) => name === this.ETname);
      this.ETimg = mechineName[0].headerImg;
      this.ETk_value = mechineName[0].K_value;
    },
    // 研究模式
    ETresult() {
      const { Resource } = Island;
      this.res = new Resource({
        $el: this.$refs.machineRes, // canvas对象
        sz: 11, // 棋盘大小
        width: 500, // canvas宽度
        content: this.desc, // 可填内容，如果没有填从空开始
      });
    },
    // 下一步还是所有的
    goStep(step) {
      if ((typeof step) === 'number') {
        this.res.goStep(step);
      } else if (step === 'first') {
        this.res.goFirstStep();
      } else if (step === 'last') {
        this.res.goLastStep();
      }
    },
    // 获取当前对一结果
    getResult() {
      Api.getMechineResultDetails({ battle_id: this.resID }).then((res) => {
        if (res.status === 0) {
          const { battle_info } = res.content;
          this.ETname = battle_info.robot_name;
          // eslint-disable-next-line no-nested-ternary
          this.whoisWIN = (battle_info.is_right === 0 ? '黑胜' : (battle_info.is_right === 1 ? '白胜' : '平局'));
          this.desc = battle_info.content;
          this.winStep = battle_info.student_steps;
          this.machineStep = battle_info.robot_steps;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
  .man-machine {
    background: #fff4da;
    height: 100%;
    width: 100%;

    .header {
      height: halvePx(170);
      width: 100%;
      display: flex;
      background: #ebdcb7;
      align-items: center;
      justify-content: center;

      .user {
        display: flex;
        align-items: center;
        width: 40%;
        height: 100%;

        .img {
          width: halvePx(100);
          height: halvePx(100);

          img {
            min-width: 100%;
            max-height: 100%;
            border-radius: 50%;
            border: halvePx(2) solid rgba(255, 255, 255, 1);
          }
        }
        .user-item {
          flex: 1;
          margin-left: halvePx(15);
          .username {
            width:90%;
            font-size: halvePx(28);
            font-family: PingFang-SC-Regular;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            text-align: center;
            margin-bottom: halvePx(10);
            span{
              color:#AE9C73;
              font-size:halvePx(24);
            }
          }
          .status {
            width: halvePx(160);
            height: halvePx(40);
            line-height: halvePx(40);
            text-align: center;
            background: rgba(248, 235, 203, 1);
            border-radius: halvePx(20);
            font-size: halvePx(24);
            font-family: PingFang-SC-Regular;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }
        }
      }

      .vs {

        margin: auto halvePx(20);
        div{
          font-size: halvePx(48);
          font-family: PingFang-SC-Bold;
          font-weight: bold;
          color: rgba(205, 189, 151, 1);
          text-align: center;
          margin-top: 50%;
        }
        .witchWin{
          width:halvePx(90);
          height:halvePx(30);
          line-height: halvePx(30);
          text-align: center;
          background:rgba(111,218,121,1);
          border-radius:halvePx(15);
          font-size:halvePx(20);
          font-family:PingFang-SC-Regular;
          font-weight:400;
          color:rgba(255,255,255,1);
          margin-top:20%;
        }
      }
    }
    .container {
      width: 80%;
      display:flex;
      align-items: center;
      justify-content: center;
      margin: 10%;
      canvas {
        width: 100%;
        height: 100%;
        display: block;
        margin: auto;
      }
    }
    .confirm-button {
      width: halvePx(270);
      height: halvePx(100);
      line-height: halvePx(100);
      text-align: center;
      background: rgba(125, 185, 255, 1);
      border-radius: halvePx(50);
      font-size: halvePx(30);
      font-family: PingFang-SC-Regular;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      margin: halvePx(50) auto 0;
    }
  }
  .longText{
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
  }
  .nav{
    width:100%;
    display:flex;
    align-items: center;
    justify-content: center;
    img{
      display:inline-block;
      height:halvePx(60);
      width:halvePx(120);
      margin:0 halvePx(20);
    }
  }
</style>
